module.exports = __webpack_public_path__ + "static/media/primeros-pasos.e5146573.png";